<ng-container>
  @for (endorsement of activeEndorsementIds$ | async; track endorsement) {
    <app-endorsement
      [endorsementId]="endorsement"
      [hideIfSigned]="shouldHideEndorsement(endorsement)"
      [documentScale]="activePackageDocument?.isSmartDoc ? 1 : documentScale"
      [isEndorsementDisabled]="shouldDisableEndorsement(endorsement)"
      [areAllEndorsementsSigned]="areAllEndorsementsSigned"
    ></app-endorsement>
    <app-endorsement-flag
      [endorsementId]="endorsement"
      [documentScale]="activePackageDocument?.isSmartDoc ? 1 : documentScale"
    ></app-endorsement-flag>
  }
</ng-container>
